<template>
  <div :class="['task', {task__completed: completed}]">
    <span class="task_index">{{index + 1}}</span>
    <div class="task_text">
      <div>
        <span :class="[{task_completed: completed}, `task__${filterValue}`]">{{ title }}</span>
        <div
          v-if="questDescription"
          class="task_merged task_content"
          v-html="questDescription"
        />
        <div
          class="task_results"
          v-if="completedCount"
        >
          {{ text }} {{ mergedCount > 1 || completedCount > 1 ? ` — ${completedCount}` : '' }}
        </div>
        <div
          class="task_merged"
          v-if="mergedCount > 1 && (mergedCount - completedCount > 0)"
          v-html="$c('На этой неделе можно выполнить %(completed_count)s раза', { completed_count: (mergedCount - completedCount) })"
        />
      </div>
      <div class="task_extra">
        <SocialLink v-if="questCode === QUEST_CODE_SELECT.SOCIAL_SHARE" />
        <QuizLink v-if="questCode === QUEST_CODE_SELECT.QUIZ_FINISH" />
      </div>
    </div>
    <span class="task_spins" v-if="!completed"><span class="task_spins-text">{{ spins }}</span></span>
    <template v-else>
      <span
        v-if="filterValue === 'DAILY'"
        class="task_spins"
      ><span class="task_spins-text">{{ spins }}</span></span>
      <svg
        v-else
        class="task_completed-ico"
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none" xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.353516" y="6.96021" width="2" height="6" transform="rotate(-45 0.353516 6.96021)" fill="white"/>
        <rect x="12.2324" y="0.797119" width="2" height="12" transform="rotate(45 12.2324 0.797119)" fill="white"/>
      </svg>
    </template>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import { QUEST_CODE_SELECT } from '@/constants'
import SocialLink from './TaskExtras/Social'
import QuizLink from './TaskExtras/Quiz'

@Component({
  components: {
    SocialLink,
    QuizLink
  }
})
class Task extends Vue {
  @Prop({
    required: true
  }) text
  @Prop({
    default: null
  }) questDescription
  @Prop({
    required: true
  }) finishedCount
  @Prop({
    required: true
  }) title
  @Prop({
    required: true
  }) index
  @Prop({
    required: true
  }) spins
  @Prop({
    default: null
  }) questCode
  @Prop({
    default: false
  }) completed
  @Prop({
    default: 0
  }) completedCount
  @Prop({
    default: 0
  }) mergedCount
  @Prop({
    required: true
  }) filterValue

  QUEST_CODE_SELECT = QUEST_CODE_SELECT
}

export default Task
</script>
<style lang="scss">
  .task {
    &_content {
      a {
        color: #ffffff;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
  .task {
    display: flex;
    align-items: flex-start;
    font-style: normal;
    font-weight: normal;
    color: #CCCCCC;
    min-height: 80px;
    padding: 25px 0;
    border-bottom: 1px solid #2C2C2C;
    box-sizing: border-box;
    width: 100%;
    transform: translateY(0);
    @include media_desktop {
      align-items: center;
    }
    &:first-child {
      border-top: 1px solid #2C2C2C;
    }
    & > * {
      vertical-align: middle;
    }
    &_text {
      font-size: 12px;
      line-height: 16px;
      flex: 1;
      padding: 0 20px 0 12px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      @include media_tablet {
        font-size: 14px;
        line-height: 18px;
      }
      @include media_desktop {
        font-size: 20px;
        line-height: 28px;
        flex-direction: row;
        align-items: center;
        padding: 0 40px 0 30px;
      }
    }
    &_results, &_merged {
      font-style: normal;
      font-weight: normal;
      color: #3bb200;
      font-size: 12px;
      line-height: 16px;
      @include media_tablet {
        font-size: 14px;
        line-height: 18px;
      }
      @include media_desktop {
        font-size: 16px;
        line-height: 24px;
      }
    }
    &_merged {
      color: #666666;
    }
    &_index {
      font-size: 14px;
      line-height: 16px;
    }
    &_spins {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
      color: #000000;
      left: -10px;
      top: 5px;
      @include media_desktop {
        top: 0;
      }
      &:before {
        content: '';
        position: absolute;
        width: 24px;
        height: 15px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
        background: #CC0022;
      }
    }
    &_spins-text {
      position: relative;
      z-index: 1;
    }
    &_extra {
      display: block;
      padding-left: 0;
      box-sizing: border-box;
      margin-top: 12px;
      @include media_desktop {
        margin-top: 0;
        padding-left: 30px;
      }
      .button {
        height: 36px;
        line-height: 36px;
        font-size: 16px;
        box-sizing: border-box;
        padding: 0 20px;
        text-transform: none;
      }
    }
    &_completed {
      text-decoration: line-through;
      color: #666666;
      &.task__DAILY {
        text-decoration: none;
        color: #CCCCCC;
      }
    }
    &_completed-ico {
      position: relative;
      right: 7px;
    }
  }
</style>
